import React from 'react';
import { withRouter} from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import EarlyAccessCTA from 'component/content/early_access';
import BBPromo from 'component/content/bb_promo';
import Popular from 'component/content/popular';


class Page extends React.Component {
  render (){
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <div className="my-5 text-center">
          <h3 className="my-3">Signup to customize and maintain your portfolio</h3>
          <img src="/static/images/customize.png" alt="" className="" style={{width: "50%"}} />
        </div>

        <div className="bg-light">
          <EarlyAccessCTA text_colour="dark"/>
        </div>

        <Popular />


        <BBPromo />

      </LandingLayout>
    )
  }
}

export default withRouter(Page);
